import React from "react";
import "./about.scss";

// Assets
import Hello from "../../assets/about/Hello.svg";


const about = () => (
  <div id="about">
    <div className="wrapper">
      <img src={Hello} alt="" />
      <h1 className="weight700 font60">
        My name is <span className="name-color">Muhd Rusyaidi</span> and I’m a <span>web designer</span> and <span>full-stack web developer</span> with 3 years of experience designing and develop high-end web application system.
      </h1>
    </div>
  </div>
);

export default about;
